import get from 'lodash/get.js';

import Model from '@/models/Model.js';
import Tag from '@/models/Tag.js';

export default class Taggable extends Model {
    static entity = 'taggables';

    static fields() {
        return {
            id: this.attr(null),
            tag_id: this.attr(null),
            taggable_id: this.attr(null),
            taggable_type: this.attr(null),
            tag: this.belongsTo(Tag, 'tag_id'),
        };
    }

    static async syncTags({ model, endpoint }) {
        await this.store().dispatch('AutoSave/setSaving', 'entities/taggables');

        const { response } = await this.api().put(
            endpoint,
            {
                tags: model.tags.map(tag => (typeof tag === 'string' ? tag : get(tag, 'name.en'))),
            },
            {
                dataTransformer: ({ data }) => {
                    const pivot = [];
                    data.tags.map(tag => {
                        tag.pivot.taggable_type = model.constructor.entity;

                        pivot.push(tag.pivot);
                    });
                    data = pivot;
                    return data;
                },
                persistBy: 'create',
            }
        );

        await this.store().dispatch('AutoSave/setSaved', 'entities/taggables');

        return response.data;
    }
}
